import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "mRank",
  computed: {},
  props: {
    ranking: {
      default: {}
    }
  },
  data() {
    return {};
  },
  methods: {
    initFn() {
      console.log("mRank");
    }
  }
};